import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { REVOCATIONS_PERMISSIONS } from "@/app/nav";
import { RevocationQueue } from "@/features/revocations/RevocationQueue";
import { type PageSearch, pageSearch } from "@/routes/paging";
import { staffRoute } from "@/routes/staff";

type RevocationsSearch = { request?: string } & PageSearch;

export const revocationsRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "approvals/revocations",
  // Set, never omit, the key: the router merges this over the raw query string.
  validateSearch: (search: Record<string, unknown>): RevocationsSearch => ({
    request: typeof search.request === "string" && search.request !== "" ? search.request : undefined,
    ...pageSearch(search),
  }),
  beforeLoad: ({ context }) => requirePermissions(context.session, REVOCATIONS_PERMISSIONS),
  component: RevocationQueue,
});
